// extracted by mini-css-extract-plugin
export default {"table_container":"table_table_container__PADTJ","search":"table_search__+VPlQ","table":"table_table__whMCp","arrow":"table_arrow__2kbHb","hidden":"table_hidden__RlQUu"};